import client from "../../auth/client";

export const getUserTableData = async (query: {
  page_size?: number;
  page?: number;
}) => {
  const res = await client.get(
    `/auth/list_all_users/?page_size=${query?.page_size}&page=${query?.page}`
  );
  return res?.data;
};

export const getAvailableRoles = async () => {
  const res = await client.get("/auth/list_user_roles/");
  return res?.data;
};

export const updateUserRole = async (reqBody: {
  user_id: string;
  role_ids: string[];
}) => {
  const res = await client.post("/auth/assign_user_roles/", reqBody);
  return res?.data;
};

export const listContractReviewClauseManagement = async ({
  feature,
}: {
  feature: string;
}) => {
  const res = await client.get("/doc_review/clause_management/list_clauses/");
  return res.data;
};

export const saveContractReviewClauseManagement = async (reqBody: {
  feature?: string;
  clause_id: string;
  rules: string;
}) => {
  const res = await client.post(
    "/doc_review/clause_management/update_redlining_clause/",
    reqBody
  );
  return res.data;
};

export const listTalkToContractClauseManagement = async ({
  feature,
}: {
  feature: string;
}) => {
  const res = await client.get(
    "/doc_review/clause_management/list_talk_to_my_contract_clause/"
  );
  return res.data;
};

export const saveTalkToContractClauseManagement = async (reqBody: {
  rules: string;
  clause_id: string;
}) => {
  const res = await client.post(
    "/doc_review/clause_management/update_talk_to_my_contract_clause/",
    reqBody
  );
  return res.data;
};
